export function toThumbnailFileName(filename) {
  const parts = filename.split(".");
  parts.pop();
  return `${parts.join(".")}_thumb.png`;
}
